<template>
  <div>
    <div>
      <el-row :gutter="10">
        <el-col :span="4" style="border-right: 1px solid #eee;">
          <el-row>
            <el-col :span="24">
              <el-button-group style="width: 100%;">
                <el-button style="width: 33%;" round class="hiaButton" :disabled="opReportDataLoading" plain @click.stop="resetAll()"><i class="el-icon-refresh"></i> Clear</el-button>
                <el-button style="width: 33%;" round title="View Queries" class="hiaButton" :disabled="opReportDataLoading" plain @click.stop="showQueriesDialog = !showQueriesDialog"><i class="el-icon-view"></i> Queries</el-button>
                <el-button style="width: 33%;" round v-if="!Object.keys(opActiveQuery).length" title="Save New Query" class="hiaButton" ref="opSaveQuery" :disabled="opReportDataLoading" plain @click="showSaveQueryPopover(false, 'opSaveQuery')"><i class="el-icon-finished"></i> Save</el-button>
                <el-dropdown ref="opQueryCommandButton" v-if="Object.keys(opActiveQuery).length" :disabled="opReportDataLoading" class="queryCommandButton" split-button plain @click="showSaveQueryPopover(false, 'opQueryCommandButton')" @command="opHandleQueryCommand">
                  <i class="el-icon-finished"></i> Save
                  <el-dropdown-menu :disabled="opReportDataLoading" slot="dropdown">
                    <el-dropdown-item icon="el-icon-edit" command="edit">Edit</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-share" command="share">Share</el-dropdown-item>
                    <el-dropdown-item command="saveAs"><i class="el-icon-finished"></i>Save As</el-dropdown-item>
                    <el-dropdown-item icon="el-icon-close" command="delete">Delete</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <el-button class="hiaButton" :disabled="opReportDataLoading" ref="addFilterButton" size="mini" plain round @click.stop="toggleAddFilterPopover()"><i class="el-icon-s-operation"></i> Add Filters</el-button> -->
              </el-button-group>
            </el-col>
          </el-row>
          <el-row style="margin: 10px 0px 0px 0px;">
            <el-col :span="24">
              <h4 class="headerWithBorder">Outpatient Filters</h4>
              <el-form class="sortableColumnsForm">
                <el-row>
                  <div v-for="(filter, index) in outpatientReport.outpatientData.filters.filter(x => !x.hidden)" :key="index">
                    <el-col :span="16">
                      <el-form-item>
                        <input :disabled="opReportDataLoading" :key="filter.column" type="checkbox" v-model="filter.active" @click="selectedFilter(filter)" /><span style="font-size: 11px; line-height: 12px;">{{ filter.columnLabel }}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <i :class="getTagClass2(filter.columnType)"></i><span class="tagSpan">{{ filter.columnType }}</span>
                    </el-col>
                  </div>
                </el-row>
              </el-form>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="20">
          <el-row style="margin: 5px 0px 0px 0px;">
            <el-col :span="6">
              <span>{{ Object.keys(opActiveQuery).length ? opActiveQuery.title : 'New Query' }}</span>
            </el-col>
            <el-col :span="12">
              <el-input size="mini" placeholder="filter all..." suffix-icon="el-icon-search" v-model="globalSearch" @input="runGlobalSearch()"> </el-input>
            </el-col>
            <el-col :span="6"> </el-col>
          </el-row>
          <el-row class="filterRow">
            <el-col :span="24">
              <i title="Filter Section" class="mdi mdi-filter-variant filterIcon"></i>
              <div class="filterBlock" v-for="filter in outpatientReport.outpatientData.filters.filter(f => f.active && !f.hidden)" :key="filter.column">
                <el-button-group :class="`query_${filter.column} filter_${filter.columnType}`" :ref="`query_${filter.column}`">
                  <el-button :disabled="opReportDataLoading" type="primary" :title="`${filterBlockTitle(filter)}`" size="mini" round plain @click="toggleFilterPopover(filter)"> {{ filterBlockLabel(filter) }}</el-button>
                  <el-button :disabled="opReportDataLoading" type="primary" title="remove" class="removeFilter" size="mini" icon="el-icon-close" round plain @click="removeFilter(filter)"></el-button>
                </el-button-group>
              </div>
            </el-col>
          </el-row>
          <el-row class="dataRow">
            <el-col :span="24">
              <slot name="customDataRow">
                <el-button v-if="opActiveTab === 'op'" class="hiaButton csvDownloadButton" :disabled="opReportDataLoading" size="mini" plain round @click="generateReportCSVLink()"><i class="mdi mdi-file-download-outline"></i> Export CSV</el-button>
                <el-tabs class="dataTabs" v-model="opActiveTab">
                  <el-tab-pane label="Dashboard" name="dashboard">
                    <dashboards :ascTableIds="outpatientReport.outpatientData.ascTableIds" type="op" :isReportSection="true" :showLevel2Audit="includeLevel2()"></dashboards>
                  </el-tab-pane>
                  <el-tab-pane label="Records" name="op">
                    <outpatientListFilter ref="outpatientFilterList" :type="dashboardType"></outpatientListFilter>
                  </el-tab-pane>
                </el-tabs>
              </slot>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="poppers">
      <el-popover ref="filterPopover" placement="bottom" width="400" :title="currentFilter.columnLabel" v-model="filterPopoverVisible">
        <div>
          <template v-if="!['date', 'tag'].some(s => s === currentFilter.columnType)">
            <el-input style="margin: 0px 0px 5px 0px;" size="mini" placeholder="filter..." suffix-icon="el-icon-search" v-model="currentFilter.filterText" @input="runTextFilter(currentFilter)" clearable> </el-input>
            <el-select v-if="currentFilter.includeUniqueValues" v-model="currentFilter.filterValues" filterable multiple collapse-tags placeholder="select multiple..." @visible-change="handleVisibleChange($event, currentFilter)" @remove-tag="handleFilterRemove($event, currentFilter)">
              <el-option v-for="item in currentFilter.uniqueValues" :key="item.key" :label="item.value" :value="item.key"> </el-option>
            </el-select>
          </template>
          <template v-if="currentFilter.columnType === 'date'">
            <el-row>
              <el-col :span="2">
                <input type="radio" value="filterText" v-model="currentFilter.dateCriteria" />
              </el-col>
              <el-col :span="22">
                <el-input :disabled="currentFilter.dateCriteria !== 'filterText'" style="margin: 0px 0px 5px 0px;" size="mini" placeholder="filter..." suffix-icon="el-icon-search" v-model="currentFilter.filterText" clearable> </el-input>
              </el-col>
            </el-row>
            <el-row style="margin: 0px 0px 0px 0px;">
              <el-col :span="2">
                <input type="radio" value="withinDate" v-model="currentFilter.dateCriteria" />
              </el-col>
              <el-col :span="22">
                <small>Within the last</small>
                <input :disabled="currentFilter.dateCriteria !== 'withinDate'" style="width: 50px; margin: 0px 5px 0px 5px;" type="number" min="0" v-model="currentFilter.withinDate" />
                <el-select style="width: 80px;" :disabled="currentFilter.dateCriteria !== 'withinDate'" v-model="currentFilter.dateOption" collapse-tags placeholder="select...">
                  <el-option v-for="item in dateFilterOptions" :key="item.key" :label="item.key" :value="item.value"> </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row style="margin: 5px 0px 0px 0px;">
              <el-col :span="2">
                <input type="radio" value="dateBetween" v-model="currentFilter.dateCriteria" />
              </el-col>
              <el-col :span="22">
                <small>between</small>
                <el-date-picker style="float: right; width: 85% !important;" :disabled="currentFilter.dateCriteria !== 'dateBetween'" class="hiaRangePicker" size="mini" format="MM/dd/yyyy" value-format="MM/dd/yyyy" v-model="currentFilter.dateBetween" type="daterange" range-separator="To" start-placeholder="Start date" end-placeholder="End date" :picker-options="dateRangePickerConfig" :clearable="false"> </el-date-picker>
              </el-col>
            </el-row>
          </template>

          <template v-if="currentFilter.columnType === 'tag'">
            <el-row>
              <el-col :span="2">
                <input type="radio" value="withinTag" v-model="currentFilter.tagCriteria" />
              </el-col>
              <el-col :span="22">
                <small>contains</small>
                <el-select style="float: right; width: 85% !important;" :disabled="currentFilter.tagCriteria !== 'withinTag'" v-model="currentFilter.filterValues" filterable multiple collapse-tags placeholder="select multiple...">
                  <el-option v-for="item in currentFilter.uniqueValues" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row style="margin: 5px 0px 0px 0px;">
              <el-col :span="2">
                <input type="radio" value="equalsTag" v-model="currentFilter.tagCriteria" />
              </el-col>
              <el-col :span="22">
                <small>equals</small>
                <el-select style="float: right; width: 85% !important;" :disabled="currentFilter.tagCriteria !== 'equalsTag'" v-model="currentFilter.filterValues" filterable multiple collapse-tags placeholder="select multiple...">
                  <el-option v-for="item in currentFilter.uniqueValues" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
              </el-col>
            </el-row>
          </template>
        </div>
        <el-button-group style="float: right; margin: 10px 0px 0px 0px;">
          <el-button class="hiaButton" type="text" :disabled="opReportDataLoading" size="mini" @click="clearFilter(currentFilter)" plain round>Clear</el-button>
          <el-button class="hiaButton" :disabled="opReportDataLoading" size="mini" @click="toggleFilterPopover(currentFilter)" plain round>Close</el-button>
          <el-button class="hiaButton" v-if="['date', 'tag'].some(s => s === currentFilter.columnType)" :disabled="opReportDataLoading" size="mini" @click="applyFilter(currentFilter)" plain round>Apply</el-button>
        </el-button-group>
      </el-popover>

      <el-popover ref="updateQueryPopper" placement="bottom" width="210" v-model="updateQueryPopOverVisible" @after-enter="handleHidePopOver('updateQueryPopper')">
        <el-form size="mini" ref="updateQueryform" label-position="top" label-width="120px" :rules="addQueryRules" :model="currentQuery">
          <el-form-item size="mini" label="Query Title" prop="title" id="addTitle">
            <el-input size="mini" :maxlength="50" type="text" id="title" v-model="currentQuery.title" clearable> </el-input>
          </el-form-item>
          <el-form-item size="mini" label="Public" prop="isPublic" id="addPublic">
            <input type="checkbox" v-model="currentQuery.isPublic" />
          </el-form-item>
        </el-form>
        <br />
        <el-button-group style="float: right; margin: 10px 0px 0px 0px;">
          <el-button class="hiaButton" type="text" size="mini" @click="updateQueryPopOverVisible = false" plain round>Cancel</el-button>
          <el-button class="hiaButton" size="mini" @click="updateQueryMeta(currentQuery)" plain round>Confirm</el-button>
        </el-button-group>
      </el-popover>

      <el-popover ref="saveQueryPopover" trigger="click" placement="bottom" v-model="addQueryPopOverVisible" @after-enter="handleHidePopOver('saveQueryPopover')">
        <el-form size="mini" ref="queryForm" label-position="top" label-width="120px" :rules="addQueryRules" :model="addQueryForm">
          <el-form-item size="mini" label="Title" prop="title" id="addTitle">
            <el-input size="mini" :maxlength="50" type="text" id="title" v-model="addQueryForm.title"> </el-input>
          </el-form-item>
          <el-form-item size="mini" label="Make Public" prop="isPublic" id="addPublic">
            <input type="checkbox" v-model="addQueryForm.isPublic" />
          </el-form-item>
        </el-form>

        <el-button-group style="float: right; margin: 10px 0px 0px 0px;">
          <el-button class="hiaButton" type="text" size="mini" @click="cancelFilter()" plain round>Cancel</el-button>
          <el-button class="hiaButton" size="mini" @click="saveQuery()" plain round>Confirm</el-button>
        </el-button-group>
      </el-popover>

      <el-popover ref="shareQueryPopper" placement="bottom" width="210" v-model="shareQueryPopOverVisible" @after-enter="handleHidePopOver('shareQueryPopper')">
        <p>Share Query with</p>
        <el-select v-model="shareQueryUsers" multiple collapse-tags placeholder="select multiple...">
          <el-option v-for="user in usersList.filter(f => f.userId !== currentTenantUserId)" :key="user.userId" :label="user.fullName" :value="user.userId"> </el-option>
        </el-select>
        <el-button-group style="float: right; margin: 10px 0px 0px 0px;">
          <el-button class="hiaButton" type="text" size="mini" @click="shareQueryPopOverVisible = false" plain round>Cancel</el-button>
          <el-button class="hiaButton" size="mini" @click="shareQuery(currentQuery)" plain round>confirm</el-button>
        </el-button-group>
      </el-popover>

      <el-popover ref="deleteQueryPopper" placement="bottom" width="210" v-model="deleteQueryPopOverVisible" @after-enter="handleHidePopOver('deleteQueryPopper')">
        <p>Delete this Query?</p>
        <el-button-group style="float: right; margin: 10px 0px 0px 0px;">
          <el-button class="hiaButton" type="text" size="mini" @click="deleteQueryPopOverVisible = false" plain round>Cancel</el-button>
          <el-button class="hiaButton" size="mini" @click="deleteQuery(currentQuery)" plain round>confirm</el-button>
        </el-button-group>
      </el-popover>
    </div>
    <div class="dialogs">
      <el-dialog :visible.sync="showQueriesDialog" :title="'Saved Queries'" width="60%" :close-on-click-modal="true" :show-close="true" append-to-body>
        <v-client-table class="hiaTable" v-loading="false" element-loading-spinner="atom-audit-loader" ref="reportQueriesGrid" id="reportQueriesGrid" :data="reportQueries.filter(x => x.type === 'op')" :columns="reportQueriesColumns" :options="reportQueriesOptions">
          <div slot="filter__isPublic">
            <input type="checkbox" @change="$refs.reportQueriesGrid.setFilter({ isPublic: $event.target.checked })" />
          </div>
          <template slot="title" slot-scope="props">
            <a href="#" title="activate this query" @click.prevent="activateQuery(props.row)">{{ props.row.title }}</a>
          </template>
          <template slot="isPublic" slot-scope="props">
            <i :style="props.row.isPublic ? 'color: #13ce66; font-size: 16px; font-weight: bold;' : 'color: #F56C6C; font-size: 16px; font-weight: bold;'" :class="props.row.isPublic ? 'el-icon-check' : ''"></i>
          </template>
          <template slot="queryActions" slot-scope="props">
            <div style="float: right;">
              <el-button :disabled="disableQuery(props.row)" :ref="`updateQuery_${props.row.reportQueryId}`" @click.native.prevent="toggleUpdateQueryPopover(props.row, `updateQuery_${props.row.reportQueryId}`)" plain round size="mini" icon="el-icon-edit" title="Edit Title" circle></el-button>
              <el-button :disabled="disableQuery(props.row)" :ref="`saveAsQuery_${props.row.reportQueryId}`" @click.native.prevent="showSaveQueryPopover(true, `saveAsQuery_${props.row.reportQueryId}`)" plain round size="mini" icon="el-icon-finished" title="Save As" circle></el-button>
              <el-button :disabled="disableQuery(props.row)" :ref="`shareQuery_${props.row.reportQueryId}`" @click.native.prevent="toggleShareQueryPopover(props.row, `shareQuery_${props.row.reportQueryId}`)" plain round size="mini" icon="el-icon-share" title="Share" circle></el-button>
              <el-button :disabled="disableQuery(props.row)" :ref="`deleteQuery_${props.row.reportQueryId}`" @click.native.prevent="toggleDeleteQueryPopover(props.row, `deleteQuery_${props.row.reportQueryId}`)" plain round size="mini" icon="el-icon-close" title="Delete" circle></el-button>
            </div>
          </template>
        </v-client-table>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import dateHelper from '@/mixins/date-helper'
  import hiaTable from '@/mixins/hiaTable'
  import outpatientListFilter from '@/views/reports/outpatientListFilter'
  import dashboards from './dashboards'
  import debounce from 'debounce'
  import HiaAuthorization from '@/mixins/hiaAuthorization'

  export default {
    name: 'opReportSection',
    mixins: [dateHelper, hiaTable, HiaAuthorization],
    props: {
      dashboardType: {
        type: String,
        required: false
      },
      getOpFilterListSlotRef: {
        type: Function,
        required: false
      }
    },
    data() {
      return {
        opActiveQuery: {},
        saveAsFlag: false,
        showQueriesDialog: false,
        deleteQueryPopOverVisible: false,
        shareQueryPopOverVisible: false,
        updateQueryPopOverVisible: false,
        shareQueryUsers: [],
        defaultDateRange: [],
        isCollapsed: true,
        addQueryForm: {
          title: '',
          isPublic: false
        },
        addQueryRules: {
          title: [{ required: true, message: 'Please Set Title' }]
        },
        addQueryPopOverVisible: false,
        loading: false,
        opFilterCollapse: 'op',
        opActiveTab: 'dashboard',
        addFilterVisible: false,
        filterPopoverVisible: false,
        currentFilter: {},
        filterValuesBackup: null,
        globalSearch: null,
        currentQuery: {},
        dateFilterOptions: [
          { key: 'days', value: 'days' },
          { key: 'weeks', value: 'weeks' },
          { key: 'months', value: 'months' },
          { key: 'years', value: 'years' }
        ],
        reportQueriesColumns: ['title', 'type', 'isPublic', 'addedFormat', 'queryActions'],
        reportQueriesOptions: {
          filterByColumn: true,
          orderBy: {
            column: 'clientName',
            ascending: true
          },
          headings: {
            title: 'Title',
            type: 'Type',
            isPublic: 'Public',
            addedFormat: 'Created',
            queryActions: ''
          },
          perPage: 15,
          texts: {
            filter: '',
            filterBy: '...'
          },
          highlightMatches: true,
          sortIcon: { is: 'none' }
        }
      }
    },
    methods: {
      ...mapActions('userAdmin/', ['GET_USERS']),
      ...mapActions('reports/', ['POST_REPORTCSV']),
      ...mapActions('reports/reportQueries/', ['GET_REPORTQUERIES', 'POST_REPORTQUERIES', 'PUT_REPORTQUERIES', 'PUT_SHAREREPORTQUERIES', 'DELETE_REPORTQUERIES']),
      ...mapMutations('reports/reportQueries/', ['UPDATE_REPORTQUERY_ACTIVE']),
      ...mapMutations('reports/', ['SET_REPORTS_OUTPATIENT_GLOBALSEARCH', 'PUSH_REPORTS_FILTERS', 'SET_REPORTS_OUTPATIENT_FILTER', 'SET_REPORTS_OUTPATIENT_REPORTFILTER', 'RESET_REPORTS_OUTPATIENT_FILTER']),
      async initialize() {
        // await this.GET_USERS()
        // await this.GET_REPORTQUERIES()
      },
      toggleFilterPopover(filter) {
        this.currentFilter = filter
        const popper = this.$refs.filterPopover
        if (popper) {
          popper.referenceElm = this.$refs[`query_${filter.column}`][0].$el
          this.filterPopoverVisible = !this.filterPopoverVisible
        }
      },
      toggleAddFilterPopover() {
        this.filterPopoverVisible = false
        const popper = this.$refs.sortableColumns
        if (popper) {
          popper.referenceElm = this.$refs.addFilterButton.$el
        }
        this.addFilterVisible = true
      },
      selectedFilter(filter) {
        this.addFilterVisible = false
        setTimeout(() => {
          if (filter.active) {
            this.toggleFilterPopover(filter)
          } else {
            this.clearFilter(filter)
          }
        }, 100)
      },
      removeFilter(filter) {
        filter.active = false
        filter.filterText = null
        filter.filterValues = []
        filter.dateBetween = []
        filter.moreThanDate = 0
        filter.withinDate = 0
        filter.dateOption = 'days'
        filter.dateCriteria = null
        this.SET_REPORTS_OUTPATIENT_FILTER(filter)
        this.filterPopoverVisible = false
        this.refreshData(filter.reportType)
      },
      clearFilter(filter) {
        this.filterPopoverVisible = false
        filter.filterText = null
        filter.filterValues = []
        filter.dateBetween = []
        filter.moreThanDate = 0
        filter.withinDate = 0
        filter.dateOption = 'days'
        filter.dateCriteria = null
        this.SET_REPORTS_OUTPATIENT_FILTER(filter)
        this.refreshData('op')
      },
      runTextFilter: debounce(function(filter) {
        this.applyFilter(filter)
      }, 400),
      applyFilter(filter) {
        this.SET_REPORTS_OUTPATIENT_FILTER(filter)
        this.refreshData(filter.reportType)
        // this.filterPopoverVisible = false
      },
      handleFilterRemove(value, filter) {
        if (filter.columnType === 'text') {
          filter.uniqueValues = filter.uniqueValues.filter(f => f.key !== value)
          this.applyFilter(filter)
        }
      },
      handleVisibleChange(val, filter) {
        if (val) {
          // Store initial state when el select dropdown opens
          this.filterValuesBackup = {
            filterValues: filter.filterValues ? [...filter.filterValues] : []
          }
        } else {
          if (this.hasFilterChanged(filter)) {
            this.applyFilter(filter)
          }
          this.filterValuesBackup = null
        }
      },
      hasFilterChanged(filter) {
        if (!this.filterValuesBackup) {
          return true
        }

        // Compare filterValues (arrays) - only check dropdown selections
        const currentValues = filter.filterValues || []
        const initialValues = this.filterValuesBackup.filterValues || []
        if (currentValues.length !== initialValues.length) {
          return true
        }
        if (currentValues.some(val => !initialValues.includes(val)) || initialValues.some(val => !currentValues.includes(val))) {
          return true
        }

        return false
      },
      runGlobalSearch: debounce(function(filter) {
        this.SET_REPORTS_OUTPATIENT_GLOBALSEARCH(this.globalSearch)
        this.refreshData('op')
      }, 400),
      filterBlockLabel(filter) {
        let displayList = [filter.columnLabel]
        if (filter.columnType !== 'date') {
          if (filter.filterText !== null && filter.filterText !== '') {
            const columnLabelIndex = displayList.indexOf(filter.columnLabel)
            displayList.push(filter.filterText)
            displayList.splice(columnLabelIndex, 1)
            console.log(displayList)
          }
          if (filter.filterValues !== null) {
            if (filter.filterValues.length) {
              const columnLabelIndex = displayList.indexOf(filter.columnLabel)
              displayList = displayList.concat(filter.filterValues)
              displayList.splice(columnLabelIndex, 1)
            }
          }
        }

        return displayList.join(',')
      },
      filterBlockTitle(filter) {
        let displayList = [filter.columnLabel]
        if (filter.columnType === 'date') {
          if (filter.dateCriteria === 'filterText' && filter.filterText !== null && filter.filterText !== '') {
            displayList.push(filter.filterText)
          }
          if (filter.dateCriteria === 'withinDate') {
            displayList.push(`Within the last ${filter.withinDate} ${filter.dateOption}`)
          }
          if (filter.dateCriteria === 'dateBetween' && filter.dateBetween.length === 2) {
            displayList.push(`between ${filter.dateBetween[0]} and ${filter.dateBetween[1]}`)
          }
        } else {
          if (filter.filterText !== null && filter.filterText !== '') {
            displayList.push(filter.filterText)
          }
          if (filter.filterValues) {
            displayList = displayList.concat(filter.filterValues)
          }
        }
        return displayList.join('\n')
      },
      resetAll() {
        this.opActiveQuery = {}
        this.RESET_REPORTS_OUTPATIENT_FILTER()
        const activeReportQuery = this.reportQueries.filter(f => f.active === true)
        if (activeReportQuery) {
          const currentFilterPayload = {
            type: 'op',
            reportQuery: activeReportQuery,
            active: false
          }
          this.UPDATE_REPORTQUERY_ACTIVE(currentFilterPayload)
        }
        // this.refreshData('ip')
        this.refreshData('op')
      },
      refreshData(reportType) {
        const defaultRef = this.$refs.outpatientFilterList
        if (defaultRef) {
          defaultRef.$refs.opReviewListGrid.setPage(1)
        } else {
          if (this.getOpFilterListSlotRef) {
            this.getOpFilterListSlotRef().$refs.opReviewListGrid.setPage(1)
          }
        }
      },
      async showSaveQueryPopover(saveAs, ref) {
        const activeQuery = this.reportQueries.find(f => f.active === true && f.type === 'op')
        this.saveAsFlag = saveAs
        if (activeQuery && !saveAs) {
          await this.updateQuery(activeQuery)
          this.opActiveQuery = this.calcActiveQuery('op')
        } else {
          const popper = this.$refs.saveQueryPopover
          if (popper) {
            popper.referenceElm = this.$refs[ref].$el
          }
          this.addQueryPopOverVisible = true
        }
      },
      toggleUpdateQueryPopover(currentQuery, ref) {
        this.currentQuery = JSON.parse(JSON.stringify(currentQuery))
        const popper = this.$refs.updateQueryPopper
        if (popper) {
          popper.referenceElm = this.$refs[ref].$el
        }
        this.updateQueryPopOverVisible = true
      },
      toggleShareQueryPopover(currentQuery, ref) {
        this.shareQueryUsers = []
        this.currentQuery = currentQuery
        const popper = this.$refs.shareQueryPopper
        if (popper) {
          popper.referenceElm = this.$refs[ref].$el
        }
        this.shareQueryPopOverVisible = true
      },
      toggleDeleteQueryPopover(currentQuery, ref) {
        this.currentQuery = currentQuery
        const popper = this.$refs.deleteQueryPopper
        if (popper) {
          popper.referenceElm = this.$refs[ref].$el
        }
        this.deleteQueryPopOverVisible = true
      },
      saveQuery() {
        this.$refs.queryForm.validate(async valid => {
          if (valid) {
            try {
              // clone; remove unique values; set local copy for future saves
              let cloneUserFilter = {}
              cloneUserFilter = JSON.parse(JSON.stringify(this.outpatientReport.outpatientData.filters.filter(f => f.active)))

              for (let i = 0; i < cloneUserFilter.length; i++) {
                cloneUserFilter[i].UniqueValues = []
              }
              const payload = {
                title: this.addQueryForm.title,
                isPublic: this.addQueryForm.isPublic,
                filter: JSON.stringify(cloneUserFilter),
                type: 'op',
                userId: this.currentTenantUserId
              }
              const response = await this.POST_REPORTQUERIES(payload)
              const currentQueryPayload = {
                type: 'op',
                reportQuery: response,
                active: true
              }
              this.UPDATE_REPORTQUERY_ACTIVE(currentQueryPayload)
              this.addQueryPopOverVisible = false
              this.clearForm()
              this.opActiveQuery = this.calcActiveQuery('op')
              console.log('b')
              this.$message({
                message: 'Query Added Successful',
                type: 'success'
              })
            } catch (err) {
              this.$message({
                message: 'Query Added Error',
                type: 'error'
              })
            }
          }
        })
      },
      async updateQuery(activeQuery) {
        try {
          let cloneUserFilter = {}
          cloneUserFilter = JSON.parse(JSON.stringify(this.outpatientReport.outpatientData.filters.filter(f => f.active)))
          for (let i = 0; i < cloneUserFilter.length; i++) {
            cloneUserFilter[i].UniqueValues = []
          }
          activeQuery.filter = JSON.stringify(cloneUserFilter)
          await this.PUT_REPORTQUERIES(activeQuery)

          this.$message({
            message: 'Query Updated Successfully',
            type: 'success'
          })
        } catch (err) {
          this.$message({
            message: 'Query Updated Error',
            type: 'error'
          })
        }
      },
      activateQuery(query, node, treenode) {
        switch (query.type) {
          case 'ip': {
            this.$emit('activateQuery', query)
            break
          }
          case 'pro': {
            this.$emit('activateQuery', query)
            break
          }
          case 'op': {
            const currentQueryPayload = {
              type: 'op',
              reportQuery: query,
              active: true
            }
            this.UPDATE_REPORTQUERY_ACTIVE(currentQueryPayload)
            const parseQuery = JSON.parse(query.filter)
            this.SET_REPORTS_OUTPATIENT_REPORTFILTER(parseQuery)
            this.opActiveQuery = this.calcActiveQuery('op')
            this.refreshData('op')
            break
          }
        }
        this.showQueriesDialog = false
      },
      cancelFilter() {
        this.addQueryPopOverVisible = false
        this.clearForm()
      },
      clearForm() {
        this.addQueryForm.title = ''
        this.addQueryForm.isPublic = false
      },
      viewToggleQueries() {
        this.isCollapsed = !this.isCollapsed
      },
      disableQuery(query) {
        return !!(query.isPublic && this.currentTenantUserId !== query.userId)
      },
      async updateQueryMeta(query) {
        try {
          await this.PUT_REPORTQUERIES(query)
          this.updateQueryPopOverVisible = false
          this.opActiveQuery = this.calcActiveQuery('op')
          this.$message({
            message: 'Query Updated Successfully',
            type: 'success'
          })
        } catch (err) {
          this.updateQueryPopOverVisible = false
          this.$message({
            message: 'Query Updated Error',
            type: 'error'
          })
        }
      },
      async deleteQuery(query) {
        try {
          await this.DELETE_REPORTQUERIES(query)
          if (query.active) {
            this.resetAll()
          }
          this.deleteQueryPopOverVisible = false
          this.$message({
            message: 'Query Deleted Successful',
            type: 'success'
          })
        } catch (err) {
          this.deleteQueryPopOverVisible = false
          this.$message({
            message: 'Query Deleted Error',
            type: 'error'
          })
        }
      },
      async shareQuery(query) {
        try {
          const payload = {
            reportQuery: query,
            userIds: this.shareQueryUsers
          }
          await this.PUT_SHAREREPORTQUERIES(payload)
          this.shareQueryUsers = []
          this.shareQueryPopOverVisible = false
          this.$message({
            message: 'Query Shared Successful',
            type: 'success'
          })
        } catch (err) {
          this.shareQueryUsers = []
          this.shareQueryPopOverVisible = false
          this.$message({
            message: 'Query Shared Error',
            type: 'error'
          })
        }
      },
      opHandleQueryCommand(command) {
        switch (true) {
          case command === 'edit':
            this.toggleUpdateQueryPopover(this.opActiveQuery, 'opQueryCommandButton')
            break
          case command === 'share':
            this.toggleShareQueryPopover(this.opActiveQuery, 'opQueryCommandButton')
            break
          case command === 'saveAs':
            this.showSaveQueryPopover(true, 'opQueryCommandButton')
            break
          case command === 'delete':
            this.toggleDeleteQueryPopover(this.opActiveQuery, 'opQueryCommandButton')
            break
        }
      },
      async generateReportCSVLink() {
        const payload = {
          docIds: this.outpatientReport.outpatientData.ascTableIds,
          type: 'op'
        }
        const response = await this.POST_REPORTCSV(payload)
        this.generateDownloadLink(response)
      },
      generateDownloadLink(href) {
        const link = document.createElement('a')
        link.setAttribute('style', 'display: hidden;')
        link.setAttribute('download', 'download')
        link.id = 'hiddenLink'
        link.href = `${this.baseApiUrl}${href}`
        document.getElementsByTagName('body')[0].appendChild(link)
        document.getElementById('hiddenLink').click()
        // remove link
        const timerId = setInterval(() => {
          document.getElementById('hiddenLink').remove()
          clearInterval(timerId)
        }, 500)
      },
      calcActiveQuery(type) {
        const activeQuery = this.reportQueries.find(f => f.active === true && f.type === type) ? this.reportQueries.find(f => f.active === true && f.type === type) : {}
        return activeQuery
      },
      getTagClass(columnType) {
        let style = ''
        switch (columnType) {
          case 'text':
            style = 'textTag'
            break
          case 'number':
            style = 'numberTag'
            break
          case 'date':
            style = 'dateTag'
            break
          case 'tag':
            style = 'tagTag'
            break
        }
        return style
      },
      getTagClass2(columnType) {
        let style = ''
        switch (columnType) {
          case 'text':
            style = 'mdi mdi-format-letter-case tagIcon magentaIcon'
            break
          case 'number':
            style = 'mdi mdi-numeric tagIcon blueIcon'
            break
          case 'date':
            style = 'mdi mdi-clock-time-three-outline tagIcon greenIcon'
            break
          case 'tag':
            style = 'mdi mdi-tag-outline tagIcon goldIcon'
            break
        }
        return style
      },
      handleHidePopOver(ref) {
        const popper = this.$refs[ref]
        const handler = e => {
          if (e.target !== popper.$el) {
            popper.doDestroy()
            popper.doClose()
          }
          document.removeEventListener('click', handler, false)
        }
        document.addEventListener('click', handler, false)
      },
      includeLevel2() {
        if (!this.tenantSetup.enableLevel2Audits) {
          return false
        }

        const projectReviewTypeFilter = this.outpatientReport?.outpatientData?.filters?.find(f => f.column === 'projectReviewType')

        // If there is no projectReviewType filter, enable level 2
        if (!projectReviewTypeFilter) {
          return true
        }

        // If filterValues is empty or doesn't exist, enable level 2
        if (!projectReviewTypeFilter.filterValues || projectReviewTypeFilter.filterValues.length === 0) {
          return true
        }

        // Otherwise, check if 'Level 2 Audit' is included
        return projectReviewTypeFilter.filterValues.includes('Level 2 Audit')
      }
    },
    watch: {
      'outpatientReport.outpatientData.filters': {
        handler(updatedFilters) {
          if (!this.currentFilter || !this.currentFilter.column) {
            return
          }

          const updatedFilter = updatedFilters?.find(f => f.column === this.currentFilter.column)
          if (!updatedFilter || !updatedFilter.uniqueValues) {
            return
          }

          if (!this.currentFilter.uniqueValues) {
            this.currentFilter.uniqueValues = []
          }

          // Add any new values that don't exist in currentFilter (compare by key)
          updatedFilter.uniqueValues.forEach(newItem => {
            const exists = this.currentFilter.uniqueValues.some(existingItem => existingItem.key === newItem.key)
            if (!exists) {
              this.currentFilter.uniqueValues.push(newItem)
            }
          })
        },
        deep: true
      }
    },
    computed: {
      ...mapState('dropdowns/', ['dropdowns']),
      ...mapState('reports/', ['inpatientReport', 'outpatientReport', 'opReportDataLoading']),
      ...mapState('reports/reportQueries/', ['reportQueries', 'usersList']),
      ...mapState('globals/', ['dateRangePickerConfig']),
      ...mapState('user/', ['user', 'currentTenantUserId', 'baseApiUrl']),
      ...mapState('managedLists/tenantSetup/', ['tenantSetup']),
      queryData() {
        if (this.reportQueries.filter(f => f.userId === this.currentTenantUserId && f.isPublic === false).length) {
          const queryData = [
            {
              id: 1,
              title: 'Personal',
              children: this.reportQueries.filter(f => f.userId === this.currentTenantUserId && f.isPublic === false)
            },
            {
              id: 2,
              title: 'Public',
              children: this.reportQueries.filter(f => f.isPublic === true)
            }
          ]
          return queryData
        }
        return []
      }
    },
    created: function() {
      this.initialize()
    },
    components: {
      // inpatientListFilter,
      outpatientListFilter,
      dashboards
    }
  }
</script>

<style scoped>
  .queryRow {
    margin: 0px 0px 10px 0px;
  }

  .filterRow {
    margin: 10px 0px 0px 0px;
    min-height: 25px;
  }

  .divider div {
    font-size: 12px;
  }

  .dataTabs {
    margin: 0px 0px 0px 0px;
  }

  .dataTabs >>> .el-tabs__content {
    overflow: visible;
  }

  .filterBlock {
    font-size: 11px;
    float: left;
    margin: 5px 0px 0px 3px;
  }

  .filterBlock button {
    padding: 3px 15px;
    width: 105px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .filterBlock button.removeFilter {
    width: auto;
  }

  .filterBlock .removeFilter {
    padding: 3px 5px;
  }

  .saveQuery {
    float: left;
    margin: 0px 0px 0px 5px;
  }

  .saveQuery button {
    padding: 3px 15px;
  }

  .saveQuery button span {
    font-size: 11px;
  }

  .hiaRangePicker {
    width: 300px;
  }

  .activeFilter {
    background: #ecf5ff;
  }

  .filterMenu.el-menu--collapse {
    width: 50px;
  }

  .filterMenu .el-menu-item,
  .filterMenu >>> .el-submenu__title {
    padding: 0px 0px 0px 0px;
    padding-left: 0px !important;
  }

  .filterMenu >>> .el-menu--inline .el-menu-item {
    padding-left: 10px !important;
  }

  >>> .filterActionButtons {
  }

  >>> .filterActionButtons button i {
    font-size: 12px;
  }

  >>> .filterActionButtons .el-popover__reference-wrapper {
    line-height: 0px;
    float: left;
    position: relative;
  }

  .queryTree >>> .el-tree-node .el-tree-node__content:hover {
    background-color: transparent;
  }

  .queryTree >>> .el-tree-node__children .el-tree-node__content:hover {
    background-color: #f5f7fa !important;
    border-radius: 20px;
  }

  .queryTree >>> .el-tree-node__content {
    height: unset;
  }

  .queryTree >>> .el-tree-node.is-current > .el-tree-node__content {
    background-color: transparent;
  }

  .queryTree >>> .el-tree-node__children > .is-current > .el-tree-node__content {
    background-color: #f5f7fa !important;
    border-radius: 20px;
  }

  /* beta styles */
  >>> .reportCard .el-card__body {
    padding: 5px;
  }

  >>> .queryCommandButton {
    width: 33%;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  >>> .queryCommandButton button {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  >>> .queryCommandButton button:hover {
    background-color: #ffffff;
    border-color: #005695;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  >>> .queryCommandButton .el-button--mini {
    width: 70%;
  }

  >>> .queryCommandButton .el-dropdown__caret-button {
    width: 30%;
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
  }

  >>> .queryCommandButton .el-dropdown__caret-button:focus {
    background-color: #ffffff;
    border-color: #005695;
  }

  >>> .queryActions {
    float: right;
  }

  >>> .queryActions button {
    padding: 7px 7px 0px 7px;
  }

  >>> .queryActions button span {
    font-size: 18px;
  }

  .reportDivider {
    margin: 14px 0;
  }

  .reportDivider .el-divider__text {
    font-size: 11px;
    padding: 0 10px;
    font-weight: 400;
  }

  .dataRow {
    margin: 10px 0px 0px 0px;
  }

  .csvDownloadButton {
    float: right;
    z-index: 1;
    position: relative;
    margin: 5px 0px 0px 0px;
  }
</style>

<style></style>
